import React from 'react';
import FieldModal from '../../../../components/modals/fieldModal';
import API from '../../../../utils/API';

class DeleteTicketModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
            success: false,
            error: null
        };
    }

    deleteTicket = () => {
        const { orgId, eventId, flowId, ticket } = this.props;
        
        this.setState({ submitting: true });

        API().delete(`Organizations/${orgId}/events/${eventId}/registrationFlows/${flowId}/tickets/${ticket._id}`)
            .then((res) => {
                if (res.status === 200) {
                    this.setState({ 
                        submitting: false,
                        success: true 
                    });
                    this.props.onDelete(ticket._id);
                }
            })
            .catch((err) => {
                this.setState({ 
                    submitting: false,
                    error: err.response?.data?.message || 'Error deleting ticket'
                });
                console.error('Error deleting ticket:', err);
            });
    };

    render() {
        const { isOpen, toggle, ticket } = this.props;
        const { submitting, success, error } = this.state;
        
        const ticketName = ticket?.label || 'this ticket';

        return (
            <FieldModal
                size="medium"
                isOpen={isOpen}
                modalTitle="Delete Ticket"
                bodyHeaderText="Are you sure you want to delete this ticket?"
                isDelete={true}
                bodyContent={() => (
                    <div>
                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}
                        <p>
                            You are about to delete the ticket: <strong>"{ticketName}"</strong>
                        </p>
                        <p>
                            This action cannot be undone. Removing this ticket will prevent attendees from selecting it during registration.
                        </p>
                    </div>
                )}
                toggle={toggle}
                actionButtonLabel={!success ? !submitting ? 'Delete' : 'Deleting...' : 'Deleted'}
                cancelButtonLabel={success ? 'Close' : 'Cancel'}
                actionButton={() => this.deleteTicket()}
                submitting={submitting}
                actionButtonDisabled={submitting || success}
            />
        );
    }
}

export default DeleteTicketModal;
